// src/store/userSlice.js
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isLoggedIn: null,
  userId: "",
  username: "",
  menuId: null,
  commCode: "",
  commMsg: "",
  permId: "",
  userInfo: {},
  menuData: [],
  myMenuData: [],
  addBtnData: [],
  token: null,
  commCodeLoaded: false,
  commMsgLoaded: false,
};


const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    //resetUser: () => initialState,
    resetUser: (state) => {
      state.isLoggedIn = false;
      state.userId = "";
      state.username = "";
      state.permId = "";
      state.userInfo = {};
      state.menuData = [];
      state.myMenuData = [];
      state.addBtnData = [];
      state.menuId = null;
      // ✅ commCode, commMsg 유지
    },

    setLoginSuccess(state, action) {
      state.isLoggedIn = true;
      state.username = action.payload.username;
      state.userId = action.payload.userId;
      if(action.payload.permId) {
        state.permId = action.payload.permId;
      }
      if(action.payload.userInfo) {
        state.userInfo = action.payload.userInfo;
      }
      if(action.payload.token) {
        state.token = action.payload.token;
      }  
    },
    logout(state) {
      state.isLoggedIn = false;   
      state.username = null;
      state.userId = null;
      state.permId = null;
      state.userInfo = {};
      state.token = null;
      state.menuData = [];
      state.myMenuData = [];
      state.addBtnData = [];
      state.menuId = null;
    },
    setUserId: (state, action) => {
      state.userId = action.payload;
    },
    setUsername: (state, action) => {
      state.username = action.payload;
    },
    setMenuId: (state, action) => {
      state.menuId = action.payload;
    },
    setCommCode: (state, action) => {
      state.commCode = action.payload;
      state.commCodeLoaded = true;
    },
    setCommMsg: (state, action) => {
      state.commMsg = action.payload;
      state.commMsgLoaded = true;
    },
    setPermId: (state, action) => {
      state.permId = action.payload;
    },
    setUserInfo: (state, action) => {
      state.userInfo = action.payload;
    },
    setMenuData: (state, action) => {
      state.menuData = action.payload;
    },
    setMyMenuData: (state, action) => {
      state.myMenuData = action.payload;
    },
    setAddBtnData: (state, action) => {
      state.addBtnData = action.payload;
    },
    setToken: (state, action) => {
      state.token = action.payload;
    },    
  },
});

export const {
  setUserId,
  setUsername,
  setMenuId,
  setCommCode,
  setCommMsg,
  setPermId,
  setUserInfo,
  setMenuData,
  setMyMenuData,
  setAddBtnData,
  setLoginSuccess,
  logout,
  resetUser,
  setToken,
} = userSlice.actions;

export const setTab = (menuId) => ({
  type: 'SET_TAB',
  payload: menuId
});

export default userSlice.reducer;
